export const HS_SERVICE_TYPE_CHAT = 0;

export const HS_FILL_FORM_EVENT = 'fill_form';
export const HS_STREAM_MESSAGE = 'stream-message';
